import request from '@/utils/request'
// 获取计费方式列表
export const getBillingList = (data) => {
    return request({
        url: '/HVAC/billing/lists',
        params: data
    })
}
// 添加计费方式
export const addBilling = (data) => {
    return request({
        url: '/HVAC/billing/manage',
        method: 'POST',
        data
    })
    // export interface Request {
    //     /**
    //      * 基础费用
    //      */
    //     basic_fee: string;
    //     /**
    //      * 小区ID
    //      */
    //     building: string;
    //     /**
    //      * 热量表id，当计费方式含热量表时，需要设置总表
    //      */
    //     heat_meter?: string;
    //     /**
    //      * 热量单价 ，单位：元/千瓦时，计费方式含热量表时需要
    //      */
    //     heat_unit_price?: string;
    //     /**
    //      * 计费方式，1 热量表，2 热量表+ 温控器，3 温控器
    //      */
    //     method: string;
    //     /**
    //      * 温控器id，小区主控，当计费方式含温控器时必须
    //      */
    //     thermostat?: string;
    //     /**
    //      * 高功率运行时单价，元/小时
    //      */
    //     uint_price_hith?: string;
    //     /**
    //      * 低功率运行时单价，元/小时
    //      */
    //     uint_price_low?: string;
    //     /**
    //      * 中功率运行时单价，元/小时
    //      */
    //     uint_price_mid?: string;
    //     [property: string]: any;
    // }
}
// 编辑计费方式
export const editBilling = (data) => {
    return request({
        url: '/HVAC/billing/manage',
        method: 'PUT',
        data
    })
    // export interface Request {
    //     /**
    //      * 同添加
    //      */
    //     basic_fee: string;
    //     /**
    //      * 同添加
    //      */
    //     heat_meter?: string;
    //     /**
    //      * 同添加
    //      */
    //     heat_unit_price?: string;
    //     /**
    //      * id
    //      */
    //     id: string;
    //     /**
    //      * 同添加
    //      */
    //     method: string;
    //     /**
    //      * 同添加
    //      */
    //     thermostat?: string;
    //     /**
    //      * 同添加
    //      */
    //     unit_price_high?: string;
    //     /**
    //      * 同添加
    //      */
    //     unit_price_low?: string;
    //     /**
    //      * 同添加
    //      */
    //     unit_price_mid?: string;
    //     [property: string]: any;
    // }
}
// 删除计费方式
export const deleteBilling = (building) => {
    return request({
        url: '/HVAC/billing/manage',
        method: 'DELETE',
        data: { building }
    })
}
// 获取计费方式详情
export const getBillingDetail = (building) => {
    return request({
        url: '/HVAC/billing/manage',
        params: { building }
    })
}
// 获取账单流水
export const getBillingRecordList = (data) => {
    return request({
        url: '/HVAC/billing_record/lists',
        params: data
    })
}
// 获取账单流水
export const getBillingMonthRecordList = (data) => {
    return request({
        url: '/HVAC/billing_month_record/lists',
        params: data
    })
}
